import {
  PricePropsData,
  PricePropsMicrocopy,
} from '../../atoms/Price/Price.types';
import { CertifiedPublisherPropsMicrocopy } from '../../molecules/CertifiedPublisher/CertifiedPublisher.types';
import {
  ReviewStarsPropsData,
  ReviewStarsPropsMicrocopy,
} from '../../molecules/ReviewStars/ReviewStars.types';

export const ProductInfoBadgeOptions = {
  Upm: 'upm',
  VerifiedSolutions: 'verifiedSolutions',
  Deprecated: 'deprecated',
} as const;

export type ProductInfoBadgeType =
  (typeof ProductInfoBadgeOptions)[keyof typeof ProductInfoBadgeOptions];

export type ProductInfoPropsMicrocopy = {
  reviewStars?: ReviewStarsPropsMicrocopy;
  badges: {
    [key in ProductInfoBadgeType]: key extends 'verifiedSolutions'
      ? {
          text: string;
          tooltip: {
            title: string;
            benefit1: string;
            benefit2: string;
            benefit3: string;
            cta: string;
          };
        }
      : {
          text: string;
          tooltip?: string;
        };
  };
  addToMyAssetSinglePackage: string;
  addToMyAssetMultiPackages: string;
  openInUnity: string;
  seeOwnedPackages: string;
  certifiedPublisher: CertifiedPublisherPropsMicrocopy;
  verifiedOrganization: string;
  verifiedIndividual: string;
  price: PricePropsMicrocopy;
  standardEulaMessage: string;
  customEulaMessage: string;
  addToFavorites?: string;
  removeFromFavorites?: string;
};

export type ProductInfoPropsData = {
  type: 'single-package' | 'multi-package';
  nbOfPackages: number;
  isEntitled: boolean;
  badges: ProductInfoBadgeType[];
  publisherName: string;
  publisherLink: string;
  isCertifiedPublisher: boolean;
  publisherAccountType?: 'organization' | 'individual';
  publisherAvatarUrl?: string;
  productTitle: string;
  price: PricePropsData;
  customEula?: string;
  reviews?: ReviewStarsPropsData;
  isFavorite?: boolean | null;
  isReviewsEnabled?: boolean;
};

export type ProductInfoPropsDataWithMicrocopy = ProductInfoPropsData & {
  microcopy: ProductInfoPropsMicrocopy;
};

export type ProductInfoPropsActions = {
  onClickProductInfo?: () => void;
  onCallToActionMount?: (el: HTMLElement | null) => void;
  onFavorite?: () => void;
  onClickReviewsLink?: () => void;
};

export type ProductInfoProps = ProductInfoPropsDataWithMicrocopy &
  ProductInfoPropsActions & {
    variant?: 'default' | 'sticky';
    className?: string;
  };
